/* eslint-disable no-bitwise */
/* eslint-disable camelcase */
/* eslint-disable import/no-cycle */
import { takeLatest, select, put } from 'redux-saga/effects'
import { Types } from '../ducks/financial'
import api from '../../services/powerapps/index'

function* getMonthlyResult(action) {
  try {
    console.log("mes = ", action.mes)
    console.log("escopo = ", action.escopo)
    const formData = new FormData()
    formData.append('acao', 'resultado_mensal')
    formData.append('mes', action.mes) // objeto enviado com a requisição indicando a rota
    formData.append('escopo', action.escopo) // objeto enviado com a requisição indicando a rota

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.log('resultado_mensal saga', res)
    console.log('object values res.data', (Object.values(res.data)))

    yield put({
      type: Types.GET_MONTHLY_RESULT_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_MONTHLY_RESULT_FAILED,
    })
  }
}

function* getIncome() {
  try {
    const formData = new FormData()
    formData.append('acao', 'receita')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('receita', Object.values(res.data))

    yield put({
      type: Types.GET_INCOME_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_INCOME_FAILED,
    })
  }
}

function* getExpense() {
  try {
    const formData = new FormData()
    formData.append('acao', 'despesa')

    const res = yield api.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.tron.log('despesa', Object.values(res.data))

    yield put({
      type: Types.GET_EXPENSE_SUCCEEDED,
      payload: Object.values(res.data),
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_EXPENSE_FAILED,
    })
  }
}

export const financialSagas = [
  takeLatest(Types.GET_MONTHLY_RESULT_REQUESTED, getMonthlyResult),
  takeLatest(Types.GET_INCOME_REQUESTED, getIncome),
  takeLatest(Types.GET_INCOME_REQUESTED, getExpense),
]
